import styled from "styled-components";
import { color } from "../../resource";
import { dateFormatter } from "../../utility/Formatter";
import Text from "../../components/Text/Text";
import { Empty, Table } from "antd";
import icon from "../../resource/icon";
import moment from "moment";
import { useEffect, useState } from "react";
import { historyProductQuota } from "../../datasource/ProductQuotaDatasource";
import {
  AllHistoryQuotaEntities_INIT,
  type AllHistoryQuotaEntities,
} from "../../entities/HistoryQuota";
import { BaseText, DescText } from "../../components/Text/Label";

export const CustomTableWrapper = styled.div`
  .ant-table-thead > tr > th {
    background-color: ${color.secondary};
    color: ${color.white};
    font-family: "IBM Plex Sans Thai";
    font-weight: 600;
    font-size: 16px;
    text-align: start;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }
  .ant-table-tbody > tr > td {
    font-family: "Sarabun";
    font-size: 16px;
    font-weight: 400;
    color: ${color.Text1};
    padding: 16px;
    text-align: start;
  }

  .ant-table-tbody > tr:nth-child(odd) {
    background-color: ${color.white};
  }

  .ant-table {
    border-radius: 8px;
    overflow: hidden;
    border: 0.3px solid ${color.placeholder};
  }
`;

function HistoryQuota() {
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const quotaId = pathSplit[3];
  const [data, setData] = useState<AllHistoryQuotaEntities>(AllHistoryQuotaEntities_INIT);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchHistory();
  }, [page]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      await historyProductQuota({
        quotaId: quotaId,
        page: page,
        take: 10,
      }).then((res) => {
        setData(res);
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "วันเวลาอัปเดต",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value: string) => (
        <BaseText>{moment(value).format("DD/MM/YYYY HH:mm")}&nbsp;น.</BaseText>
      ),
    },
    {
      title: "กิจกรรม",
      dataIndex: "action",
      key: "action",
      render: (value: string) => <BaseText>{value || "-"}</BaseText>,
    },
    {
      title: "ผู้ใช้งาน",
      dataIndex: "updatedBy",
      key: "updatedBy",
      render: (value: string, row: any) => (
        <>
          <BaseText>{value || "-"}</BaseText>
          <DescText>{row.role}</DescText>
        </>
      ),
    },
  ];

  return (
    <CustomTableWrapper style={{ marginTop: 22 }}>
      <div style={{ marginTop: 22 }}>
        <Table
          loading={loading}
          scroll={{ y: 600 }}
          columns={columns}
          dataSource={data?.data}
          pagination={{
            position: ["bottomCenter"],
            current: page,
            pageSize: 10,
            total: data.count || 0,
            onChange: (page) => {
              setPage(page);
            },
          }}
          locale={{
            emptyText: (
              <div style={{ display: "flex", justifyContent: "center", padding: "6%" }}>
                <Empty
                  image={icon.emptyHistoryPoint}
                  description={
                    <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                      ไม่มีรายการประวัติ
                    </Text>
                  }
                />
              </div>
            ),
          }}
        />
      </div>
    </CustomTableWrapper>
  );
}

export default HistoryQuota;
